var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" Usage Report ")]),_c('v-card-text',[_c('ReportFilters',{on:{"refresh":_vm.refresh}}),_c('TableTopUsings'),_c('GraphTopFeatures'),_c('GraphFeedbackItems'),_c('GraphTopDestinations')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }